export enum SearchFiltersOptionTypesEnumByNumber {
  TYPE_SUBJECT_KNM,
  TYPE_KNM,
  YEAR_KNM,
  TYPE_OF_STATE_SUPERVISION,
  MONTH_KNM,
  STATUS_KNM,
}
